import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0175',
    ecrans: ['00-2'],
    params: [
        '?reference'
    ]
});

